module.exports = __webpack_public_path__ + "img/elu.3a237f78.jpg";